import { PageLoaderContext } from '@/providers/PageLoaderProvider';
import { useContext } from 'react';

export const usePageLoader = () => {
  const { setLoading } = useContext(PageLoaderContext);
  return { setLoading };
};
